import { Directive, HostBinding, Input, OnChanges, OnInit } from '@angular/core';

/**
 * Disabled Directive
 *
 * This directive handles common logic for disabling HTML elements. The host element will be greyed out and pointer events will be disabled
 * when this directive is applied.
 *
 * This is styling only: because the directive declares its own `disabled` input, `[disabled]` on the host binds here instead of to the
 * native DOM property. A form control still accepts keyboard input, and a hidden one (e.g. `.custom-control-input`) is still activated by
 * clicking its label, so put this directive on the label and give the control its own `[disabled]` or `[readonly]`.
 *
 * Input Properties:
 *  1. disabled: boolean. If disabled is true then the HTML element will be greyed out and pointer events will be set to 'none'.
 *  If no input is passed then the HTML element will be disabled by default.
 */

@Directive({
    standalone: false,
    selector: '[ycnDisabled]',
})
export class DisabledDirective implements OnChanges, OnInit {
    @Input() disabled?: boolean = false;

    @HostBinding('class.disabled') classDisabled: boolean = false;

    @HostBinding('style.pointer-events') pointerEvents: string = 'auto';

    ngOnInit(): void {
        this.updateDisabledStyling();
    }

    ngOnChanges(): void {
        this.updateDisabledStyling();
    }

    updateDisabledStyling(): void {
        this.pointerEvents = this.disabled ? 'none' : 'auto';
        this.classDisabled = !!this.disabled;
    }
}
